
import { Role, TransactionStatus, UserTier, AffiliateStats, Transaction, PayoutRequest, MarketingAsset, User, SystemSettings } from './types';

export const MOCK_USERS: User[] = [
  {
    id: 'admin_01',
    name: 'Admin',
    email: 'admin@signalviet.com',
    role: Role.ADMIN,
    avatar: 'https://ui-avatars.com/api/?name=Admin+Tong&background=0D8ABC&color=fff',
    status: 'ACTIVE',
    registerDate: '2023-01-01',
    registerIP: '127.0.0.1',
    lastLogin: new Date().toISOString(),
    password: '123@5678',
    phone: '0909000001',
    telegramId: 'admin_signal',
    tradingViewId: 'admin123',
    referralCode: 'ADMIN',
    groupId: 1,
    clickCount: 0,
    totalReferrals: 0,
    totalSales: 0,
    incomeWallet: 0,
    rewardWallet: 0,
    subscriptionExpiry: '2099-12-31',
    totalMonthsPaid: 0,
    currentTier: UserTier.LEVEL_3
  }
];

export const DEFAULT_SETTINGS: SystemSettings = {
  general: {
    siteName: 'SignalViet Affiliate Pro',
    cookieDuration: 30,
    attributionModel: 'LAST_CLICK',
  },
  commission: {
    t1_amount: 6,
    t2_amount: 7.5,
    t3_amount: 9,
    k1_amount: 3,
    k2_amount: 4.5,
    k3_amount: 6
  },
  payout: {
    minWithdrawal: 50,
    holdDays: 14,
    payoutDates: '15, 30'
  }
};

export const MOCK_ASSETS: MarketingAsset[] = [];

export const CHART_DATA = [];
